import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Import pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/About';
import PortfolioPage from './pages/Portfolio';
import ContactPage from './pages/Contact';
import ScheduleConsultationPage from './pages/ScheduleConsultationPage';
import WebDevelopmentPage from './pages/services/WebDevelopmentPage';
import MobileDevelopmentPage from './pages/services/MobileDevelopmentPage';
import WordPressDevelopmentPage from './pages/services/WordPressDevelopmentPage';
import SystemArchitecturePage from './pages/services/SystemArchitecturePage';
import DigitalTransformationPage from './pages/services/DigitalTransformationPage';
import MaintenanceSupportPage from './pages/services/MaintenanceSupportPage';
import PortfolioDetailPage from './pages/PortfolioDetailPage';
import AdminPage from './pages/AdminPage';
import CookiePolicy from './pages/legal/CookiePolicy';
import TermsOfService from './pages/legal/TermsOfService';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import EAACompliancePage from './pages/services/EAACompliancePage';
import EAAComplianceScannerPage from './pages/services/EAAComplianceScannerPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';

function App() {
  return (
    <div className="App">
      <GoogleReCaptchaProvider reCaptchaKey="6Ld4tnorAAAAAPjtxl-ZF7wRcBVTQYB6Lf9AQfnP">
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug" element={<PortfolioDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/schedule-consultation" element={<ScheduleConsultationPage />} />
            {/* Services */}
            <Route path="/services/web-development" element={<WebDevelopmentPage />} />
            <Route path="/services/mobile-development" element={<MobileDevelopmentPage />} />
            <Route path="/services/wordpress-development" element={<WordPressDevelopmentPage />} />
            <Route path="/services/system-architecture" element={<SystemArchitecturePage />} />
            <Route path="/services/digital-transformation" element={<DigitalTransformationPage />} />
            <Route path="/services/maintenance-support" element={<MaintenanceSupportPage />} />
            <Route path="/services/eaa-compliance" element={<EAACompliancePage />} />
            <Route path="/services/eaa-compliance-scanner" element={<EAAComplianceScannerPage />} />
            {/* Legal */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* Admin */}
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Router>
      </GoogleReCaptchaProvider>
    </div>
  );
}

export default App;